// Форматтеры значений AI-блоков — имена совпадают с backend FORMATTERS
// (src/ai/blocks.py): int | money | pct | float2.

export function formatInt(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return value === null || value === undefined ? '—' : String(value);
  return num.toLocaleString('ru-RU');
}

export function formatMoney(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '—';
  return `${num.toLocaleString('ru-RU', { maximumFractionDigits: 2 })} ₽`;
}

export function formatPct(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '—';
  return `${num.toLocaleString('ru-RU', { maximumFractionDigits: 2 })} %`;
}

export function formatFloat2(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '—';
  return num.toLocaleString('ru-RU', { maximumFractionDigits: 2 });
}

export function formatterByName(name) {
  switch (name) {
    case 'money': return formatMoney;
    case 'pct': return formatPct;
    case 'float2': return formatFloat2;
    case 'int': return formatInt;
    default: return (v) => (v === null || v === undefined ? '—' : String(v));
  }
}

export function formatDateTime(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}
